export default __webpack_public_path__ + "static/php-86e3a0d9e1dd0c20d6920a80bd5796f3.png";